import React from "react"
import { useDispatch } from "react-redux"
import { Trans, useTranslation } from "react-i18next"
import { DIALOG_KEYS } from "constants/dialogKeys"
import { NAVIGATE_TO_PREMIUM_PLANS_PAGE } from "constants/events"
import { AppDispatch } from "appRedux/store"
import { useAppSelector } from "appRedux/hooks"
import { closeActiveDialogWithDelay } from "appRedux/slices/globalSlice"
import useSubscriptionExpiryReminder from "hooks/useSubscriptionExpiryReminder"
import PremiumLogo from "components/atoms/_icons/PremiumLogo"
import Dialog from "components/atoms/Dialog"

export default function SubscriptionExpiringReminder() {
  const expireDate = useAppSelector((state) => state.premium.expireDate)
  const activeDialog = useAppSelector((state) => state.global.globalDialog.activeDialog)

  const dispatch = useDispatch() as AppDispatch
  const { t } = useTranslation()

  const { remainingDays } = useSubscriptionExpiryReminder({ expiryDate: expireDate || "" })

  function handleRepurchaseSubscription() {
    document.dispatchEvent(new CustomEvent(NAVIGATE_TO_PREMIUM_PLANS_PAGE))
    handleCloseSubscriptionExpiringReminderDialog()
  }

  function handleCloseSubscriptionExpiringReminderDialog() {
    dispatch(closeActiveDialogWithDelay())
  }

  return (
    <Dialog
      message={<Trans
        i18nKey={"premium.subscriptionExpiringReminder"}
        values={{ remainingDays }}
        components={{
          strong: <strong style={{
            fontWeight: 700
          }}/>,
          br: <br/>
        }}
      />}
      icon={<PremiumLogo width={64} height={64}/>}
      buttons={[
        { label: t("premium.repurchaseSubscription"), mode: "white", loading: false, onClick: handleRepurchaseSubscription },
        { label: t("general.discard"), mode: "primary", loading: false, onClick: handleCloseSubscriptionExpiringReminderDialog }
      ]}
      disableBackdropClose={true}
      open={activeDialog === DIALOG_KEYS.SUBSCRIPTION_REMINDER}
      onClose={handleCloseSubscriptionExpiringReminderDialog}
    />
  )
}
